<template>
  <SignupFieldComponent
    :field
    :value="model"
    :rules
    v-slot="{ id, invalid, touch }"
  >
    <select
      :id
      v-model="model"
      class="form-select"
      :class="{ 'is-invalid': invalid }"
      @blur="touch"
    >
      <option
        v-for="option in options"
        :key="String(option.value)"
        :value="option.value"
      >
        {{ $t(option.label) }}
      </option>
    </select>
  </SignupFieldComponent>
</template>

<script setup lang="ts" generic="V extends string | number | boolean">
import type { ValidationRuleCollection } from "@vuelidate/core";
import type { FieldOption } from "./fieldOptions";
import type { GeneratorReviewKey } from "./fieldKeys";
import SignupFieldComponent from "./SignupFieldComponent.vue";

withDefaults(
  defineProps<{
    field: GeneratorReviewKey;
    options: readonly FieldOption<V>[];
    rules?: ValidationRuleCollection;
  }>(),
  { rules: () => ({}) }
);

// v-model on a select hands back the option's own value, not its string attribute, so booleans survive.
const model = defineModel<V | null>({ default: null });
</script>
